var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1367_5351)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1715 3.75728L12.0606 2.64637C11.4748 2.06059 10.5251 2.06058 9.93926 2.64637L8.82835 3.75728H7.25728C6.42886 3.75728 5.75728 4.42886 5.75728 5.25728V6.82835L4.64637 7.93926C4.06059 8.52505 4.06058 9.4748 4.64637 10.0606L5.75728 11.1715V12.7426C5.75728 13.571 6.42886 14.2426 7.25728 14.2426H8.82835L9.93926 15.3535C10.5251 15.9393 11.4748 15.9393 12.0606 15.3535L13.1715 14.2426H14.7426C15.571 14.2426 16.2426 13.571 16.2426 12.7426V11.1715L17.3535 10.0606C17.9393 9.4748 17.9393 8.52505 17.3535 7.93926L16.2426 6.82835V5.25728C16.2426 4.42886 15.571 3.75728 14.7426 3.75728H13.1715ZM12.6108 4.61084C12.7046 4.70461 12.8318 4.75728 12.9644 4.75728H14.7426C15.0187 4.75728 15.2426 4.98114 15.2426 5.25728V7.03546C15.2426 7.16807 15.2952 7.29524 15.389 7.38901L16.6464 8.64637C16.8416 8.84163 16.8416 9.15822 16.6464 9.35348L15.389 10.6108C15.2952 10.7046 15.2426 10.8318 15.2426 10.9644V12.7426C15.2426 13.0187 15.0187 13.2426 14.7426 13.2426H12.9644C12.8318 13.2426 12.7046 13.2952 12.6108 13.389L11.3535 14.6464C11.1582 14.8416 10.8416 14.8416 10.6464 14.6464L9.38901 13.389C9.29524 13.2952 9.16807 13.2426 9.03546 13.2426H7.25728C6.98114 13.2426 6.75728 13.0187 6.75728 12.7426V10.9644C6.75728 10.8318 6.70461 10.7046 6.61084 10.6108L5.35348 9.35348C5.15822 9.15822 5.15822 8.84163 5.35348 8.64637L6.61084 7.38901C6.70461 7.29524 6.75728 7.16807 6.75728 7.03546V5.25728C6.75728 4.98114 6.98114 4.75728 7.25728 4.75728H9.03546C9.16807 4.75728 9.29524 4.70461 9.38901 4.61084L10.6464 3.35348C10.8416 3.15822 11.1582 3.15822 11.3535 3.35348L12.6108 4.61084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9644 4.75728C12.8318 4.75728 12.7046 4.70461 12.6108 4.61084L11.3535 3.35348C11.1582 3.15822 10.8416 3.15822 10.6464 3.35348L9.38901 4.61084C9.29524 4.70461 9.16807 4.75728 9.03546 4.75728H7.25728C6.98114 4.75728 6.75728 4.98114 6.75728 5.25728V7.03546C6.75728 7.16807 6.70461 7.29524 6.61084 7.38901L5.35348 8.64637C5.15822 8.84163 5.15822 9.15822 5.35348 9.35348L6.61084 10.6108C6.70461 10.7046 6.75728 10.8318 6.75728 10.9644V12.7426C6.75728 13.0187 6.98114 13.2426 7.25728 13.2426H9.03546C9.16807 13.2426 9.29524 13.2952 9.38901 13.389L10.6464 14.6464C10.8416 14.8416 11.1582 14.8416 11.3535 14.6464L12.6108 13.389C12.7046 13.2952 12.8318 13.2426 12.9644 13.2426H14.7426C15.0187 13.2426 15.2426 13.0187 15.2426 12.7426V10.9644C15.2426 10.8318 15.2952 10.7046 15.389 10.6108L16.6464 9.35348C16.8416 9.15822 16.8416 8.84163 16.6464 8.64637L15.389 7.38901C15.2952 7.29524 15.2426 7.16807 15.2426 7.03546V5.25728C15.2426 4.98114 15.0187 4.75728 14.7426 4.75728H12.9644Z",
    fill: "#339999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6869 7.68709L10.3334 11.0406L8.64648 9.35375L9.35359 8.64665L10.3334 9.62643L12.9798 6.97998L13.6869 7.68709Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1367_5351",
    x: -1,
    y: -1,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1367_5351"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1367_5351",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedicon);
export default __webpack_public_path__ + "static/media/verifiedicon.3fe9e173f9f969a281dfc2dff73a3a6f.svg";
export { ForwardRef as ReactComponent };